import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/OrganizerManagement';

const getListEventOfOrganizerReducer = handleActions({
    [Actions.GetListEventOfOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListEventOfOrganizerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListEventOfOrganizerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListEventOfOrganizer]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getDetailOfOrganizerReducer = handleActions({
    [Actions.GetDetailOfOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailOfOrganizerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailtOfOrganizerRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailOfOrganizer]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const approveOrganizerReducer = handleActions({

    [Actions.ApproveRegisterRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.ApproveRegisterRequestedReveived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.ApproveRegisterRequestedReveivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearApprovedRegister]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const rejectOrganizerReducer = handleActions({

    [Actions.RejectRegisterRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.RejectRegisterRequestedReveived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.RejectRegisterRequestedReveivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearRejectedRegister]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const sendInvoiceReducer = handleActions({

    [Actions.SendInvoiceRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.SendInvoiceRequestedReveived]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
    }),
    [Actions.SendInvoiceRequestedReveivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearSendInvoice]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const getCsvOrganizerReducer = handleActions({
    [Actions.GetCsvOrganizerRequested]: (state) => ({
        ...state,
        isFetching: true,
        errors: {},
        success: false,
    }),
    [Actions.GetCsvOrganizerRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetCsvOrganizerReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.GetCsvOrganizerClear]: () => ({
        isFetching: false,
        data: '',
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: '',
    errors: {},
    success: false,
});

export default combineReducers({
    get: getListEventOfOrganizerReducer,
    getDetail: getDetailOfOrganizerReducer,
    approve: approveOrganizerReducer,
    reject: rejectOrganizerReducer,
    sendInvoice: sendInvoiceReducer,
    getCsvOrganizer: getCsvOrganizerReducer,
});
